import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import {
  arrangementOptions,
  BACKGROUND_ARRANGEMENT,
  BACKGROUND_POSITION,
  BACKGROUND_REPEAT,
  positionOptions,
  repeatOptions,
} from 'hb-builder/constants/imageArrangement';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const ImageArrangement = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab<SectionItemAttributes>, 'onChange' | 'item'>) => {
  const [arrangementValue, setArrangementValue] = useState(
    item.attributes?.containerBackgroundSize || BACKGROUND_ARRANGEMENT.COVER,
  );
  const [positionValue, setPositionValue] = useState(
    item.attributes?.containerBackgroundPosition || BACKGROUND_POSITION.CENTER,
  );
  const [repeatValue, setRepeatValue] = useState(
    item.attributes?.containerBackgroundRepeat || BACKGROUND_REPEAT.NO_REPEAT,
  );

  const handleChangeArrangement = (e) => {
    setArrangementValue(e.value);

    onChange({
      id: item.id,
      settingKey: 'attributes.containerBackgroundSize',
      value: e.value,
    });
  };

  const handleChangePosition = (e) => {
    setPositionValue(e.value);

    onChange({
      id: item.id,
      settingKey: 'attributes.containerBackgroundPosition',
      value: e.value,
    });
  };

  const handleChangeRepeat = (e) => {
    setRepeatValue(e.value);

    onChange({
      id: item.id,
      settingKey: 'attributes.containerBackgroundRepeat',
      value: e.value,
    });
  };

  const valueSelected = getReactSelectValue(
    arrangementOptions,
    arrangementValue,
  );

  const positionValueSelected = getReactSelectValue(
    positionOptions,
    positionValue,
  );

  const repeatValueSelected = getReactSelectValue(repeatOptions, repeatValue);

  return (
    <Box flexDirection="column">
      <ImageSettingWrapper>
        <InputTitle
          id="heroSettingsImageArrangement"
          label={__('Image arrangement')}
        />

        <ReactSelectInput
          id="heroSettingsImageArrangement"
          name="heroSettingsImageArrangement"
          onChange={handleChangeArrangement}
          options={arrangementOptions}
          placeholder={valueSelected?.label}
          value={valueSelected}
          variant="small"
          width={155}
        />
      </ImageSettingWrapper>
      {arrangementValue !== BACKGROUND_ARRANGEMENT.COVER && (
        <ImageSettingWrapper>
          <InputTitle id="heroSettingsImageRepeat" label={__('Image repeat')} />
          <ReactSelectInput
            id="heroSettingsImageRepeat"
            name="heroSettingsImageRepeat"
            onChange={handleChangeRepeat}
            options={repeatOptions}
            value={repeatValueSelected}
            width={155}
          />
        </ImageSettingWrapper>
      )}
      <ImageSettingWrapper>
        <InputTitle
          id="heroSettingsImagePosition"
          label={__('Image position')}
        />
        <ReactSelectInput
          id="heroSettingsImagePosition"
          name="heroSettingsImagePosition"
          onChange={handleChangePosition}
          options={positionOptions}
          value={positionValueSelected}
          width={155}
        />
      </ImageSettingWrapper>
    </Box>
  );
};

export default ImageArrangement;

const ImageSettingWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
